<kendo-dropdownlist [data]="items"
                    [value]="itemSelected"
                    [textField]="textField"
                    [valueField]="valueField">
  <ng-template kendoDropDownListItemTemplate let-dataItem>
    <div class="w-100 labels" *ngIf="dataItem">
      <div (click)="setSelectedItem(dataItem)"
           [ngClass]="{'selected': itemSelected && dataItem[valueField] === itemSelected[valueField]}"
           class="d-flex align-items-center">
        <div class="w-100 mr-2">{{ dataItem[textField] }}</div>
        <fa-icon *ngIf="itemSelected && dataItem[valueField] === itemSelected[valueField]"
                 icon="times"
                 class="close"
                 (click)="setUnselectedItem($event)"></fa-icon>
      </div>
    </div>
  </ng-template>

  <ng-template kendoDropDownListValueTemplate let-dataItem>
    <div *ngIf="dataItem" class="items">
      <div class="d-flex selected">
        <div class="mr-2">{{ dataItem[textField] }}</div>
      </div>
    </div>
  </ng-template>
  <ng-template kendoDropDownListNoDataTemplate>
    <span>Nessun dato presente</span>
  </ng-template>
</kendo-dropdownlist>
